'use client'

import Image from 'next/image'
import Link from 'next/link'
import { FadeIn } from '@/app/components/FadeIn'
import asset from 'public/man.png'  

export default function About() {
  const teamMembers = [
    { name: 'Eason Zhao', phone:'0450 226 877', img: '/man.png' },
     { name: 'Kevin Kao', phone:'0435 905 131', img: '/man.png' },
      { name: 'Leo Li', phone:'0425 460 711', img: '/man.png' },
  ]

  return (
    <div className="w-full min-h-screen bg-gray-100 text-gray-900">
      {/* Hero Section */}
      <section className="relative w-full h-[60vh] flex items-center justify-center">
        <Image
          src="/fitout.webp"
          alt="About Hero"
          fill
          priority
          className="object-cover"
        />
        <div className="absolute inset-0 bg-black/60" />
        <h1 className="relative text-4xl md:text-6xl font-bold text-white z-10 drop-shadow-lg">
          About Us
        </h1>
      </section>

      {/* Company Intro */}
      <section className="max-w-6xl mx-auto py-20 px-6 grid md:grid-cols-2 gap-12 items-center">
        <FadeIn y={40}>
          <div>
            <h2 className="text-3xl font-semibold mb-6">Who We Are</h2>
            <p className="text-gray-700 leading-relaxed mb-4">
              <span className="font-semibold text-gray-900">Simoom</span> is a
              trusted builder company specialising in two core areas:
              <span className="font-semibold text-gray-900"> Shop Fitouts</span>{' '}
              and
              <span className="font-semibold text-gray-900">
                {' '}
                Residential Construction
              </span>
              . With a strong focus on{' '}
              <span className="font-semibold text-gray-900">
                quality craftsmanship
              </span>
              , attention to detail, and timely project delivery, we are
              committed to turning concepts into reality.
            </p>
            <p className="text-gray-700 leading-relaxed mb-4">
              In the commercial space, we provide tailored
              <span className="font-semibold text-gray-900">
                {' '}
                shop fitout solutions
              </span>{' '}
              that bring brands to life and create functional,
              customer-focused environments. For residential projects, we
              deliver construction services that combine{' '}
              <span className="font-semibold text-gray-900">modern design</span>{' '}
              with{' '}
              <span className="font-semibold text-gray-900">
                practical living
              </span>
              , ensuring each home is built to the highest standards.
            </p>
            <p className="text-gray-700 leading-relaxed">
              At Simoom, we value{' '}
              <span className="font-semibold text-gray-900">
                long-term relationships
              </span>
              ,{' '}
              <span className="font-semibold text-gray-900">
                transparent communication
              </span>
              , and{' '}
              <span className="font-semibold text-gray-900">excellence</span> in
              every stage of the building process.
            </p>
          </div>
        </FadeIn>

        <FadeIn x={40}>
          <div className="relative w-full h-80 rounded-xl overflow-hidden shadow-lg">
            <Image
              src="/about.webp"
              alt="About Simoom"
              fill
              className="object-cover"
            />
          </div>
        </FadeIn>
      </section>

      {/* Our Clients Section */}
      <section className="w-full bg-gray-50 py-16 overflow-hidden">
        <div className="max-w-6xl mx-auto px-6">
          <FadeIn y={20}>
            <h2 className="text-3xl font-semibold mb-8 text-center text-black">
              Our Clients
            </h2>
          </FadeIn>
      
          <div className="relative w-full overflow-hidden">
            <div className="flex animate-scroll space-x-12 items-center">
              
              <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
              
              <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
      
               <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
              <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
               <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
              <Image src="/UB.webp" alt="Client 1" width={140} height={70} />
              <Image src="/HANOK.webp" alt="Client 2" width={140} height={70} />
            </div>
          </div>
        </div>
      </section>


      {/* Team Section */}
      <section className="bg-white py-20">
        <div className="max-w-6xl mx-auto px-6">
          <FadeIn y={40}>
            <h2 className="text-3xl font-semibold mb-12 text-center text-gray-900">
              Meet Our Team
            </h2>
          </FadeIn>

          <div className="grid grid-cols-2 md:grid-cols-3 gap-15">
            {teamMembers.map((member, idx) => (
              <FadeIn key={idx} y={30} delay={0.1 * idx}>
                <div className="flex flex-col items-center text-center">
                  <div className="w-30 h-30 relative mb-6 rounded-full overflow-hidden shadow-md">
                    <Image
                      src={member.img}
                      alt={member.name}
                      fill
                      className="object-cover"
                    />
                  </div>
                  <h3 className="text-xl font-medium text-gray-900">
                    {member.name}
                  </h3>
                  <p className="text-gray-500">{member.phone}</p>
                </div>
              </FadeIn>
            ))}
          </div>
        </div>
      </section>

      {/* Core Values / Footer CTA */}
      <section className="max-w-4xl mx-auto py-20 px-6 text-center">
        <FadeIn y={40}>
          <h2 className="text-3xl font-semibold mb-6 text-gray-900">
            Our Values
          </h2>
        </FadeIn>
        <FadeIn y={40} delay={0.2}>
          <p className="text-gray-700 mb-10 leading-relaxed">
            We value <span className="font-semibold">quality</span>,{' '}
            <span className="font-semibold">integrity</span>, and{' '}
            <span className="font-semibold">innovation</span> to build spaces
            that truly serve our clients.
          </p>
        </FadeIn>
        <FadeIn y={20} delay={0.4}>
          <Link href="/" className="inline-block">
            <button className="px-8 py-3 bg-black text-white rounded-lg shadow hover:bg-white hover:text-black transition cursor-pointer">
              Back
            </button>
          </Link>
        </FadeIn>
      </section>
    </div>
  )
}

